import { Box } from '@mui/material'
import backgroundError from '@/assets/images/something-broken.png'

const ErrorPage = () => {
  return (
    <Box
      id="error-page"
      sx={{
        background: `url(${backgroundError})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        width: '100%',
        height: '800px'
      }}
    ></Box>
  )
}

export default ErrorPage
